import { SxProps, Theme } from '@mui/material'
import React from 'react'
import { BannerKey } from 'src/Libs/banners'
import { BannerCloseType, BannerCloseTypes } from '../types'
import CloseIconButton from './CloseIconButton'
import CloseMenuButton from './CloseMenuButton'

interface Props {
  bannerKey: BannerKey
  closeType: BannerCloseType
  onRemoveSuccessMessageKey?: string
  sxCloseIcon?: SxProps<Theme>
}

/**
 * This component is a close action for a banner. Their are two types of close actions: Via an icon or via a menu.
 */
const CloseAction: React.FC<Props> = ({ bannerKey, closeType, onRemoveSuccessMessageKey, sxCloseIcon }) => {
  if (closeType === BannerCloseTypes.Temporary) {
    return <CloseIconButton bannerKey={bannerKey} sxCloseIcon={sxCloseIcon} />
  }

  return <CloseMenuButton bannerKey={bannerKey} onRemoveSuccessMessageKey={onRemoveSuccessMessageKey} sxCloseIcon={sxCloseIcon} />
}

export default CloseAction
